import { useCallback, useEffect, useMemo, useState } from 'react';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { headerFn } from './utils/placmentTrackerTableHeader';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import SessionTable from '../sessionTable/SessionTable';
import ChangePlacementStatus from './components/ChangePlacementStatus';
import { useSelector } from 'react-redux';
import ChooseCourse from './components/ChooseCourse';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Search } from '@mui/icons-material';
import { getPlacementTrackerTable } from '../../../redux/features/generalSlice';
import PlacementTrackerPatchComponent from './components/PlacementTrackerPatchComponent';

export default function PlacementTrackerTable() {
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    checkedRowIds: [],
    hiddenColumns: [],
  });
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const placementTrackerTableData = useSelector((state) => state.general.placementTrackerTable.data);
  const meta = useSelector((state) => state.general.placementTrackerTable.meta);
  const placementTrackerTableLoading = useSelector((state) => state.general.placementTrackerTable.loading);

  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
    }),
    [tableState?.page, tableState?.pageSize, tableState?.search, refresh],
  );

  useEffect(() => {
    dispatch(getPlacementTrackerTable(dispatchParams));
  }, [dispatchParams, dispatch]);

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });
  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);
  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'view sessions',
        title: 'View Sessions',
        maxWidth: 'md',
        render: ({ row }) => <SessionTable row={row} />,
      },
      {
        actionKey: 'Change Status',
        title: 'Change Status',
        maxWidth: 'md',
        render: ({ row }) => <ChangePlacementStatus row={row} setModalState={setModalState} setRefresh={setRefresh} />,
      },
      {
        actionKey: 'Choose Course',
        title: 'Choose Course',
        maxWidth: 'md',
        render: ({ row }) => <ChooseCourse />,
      },
      {
        actionKey: 'First InterViewStatus',
        title: 'First Interview Status',
        maxWidth: 'md',
        render: ({ row }) => (
          <PlacementTrackerPatchComponent type={0} setRefresh={setRefresh} row={row} setModalState={setModalState} />
        ),
      },
      {
        actionKey: 'Final InterViewStatus',
        title: 'Final Interview Status',
        maxWidth: 'md',
        render: ({ row }) => (
          <PlacementTrackerPatchComponent type={1} setRefresh={setRefresh} row={row} setModalState={setModalState} />
        ),
      },
    ],
    [],
  );

  const activeConfig = useMemo(() => {
    if (!Array.isArray(modalConfigs) || !modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  const header = useMemo(() => headerFn({ setModalState }), []);

  return (
    <GlobalWrapper
      title={'Placement Tracker'}
      actions={
        <Button variant="outlined" onClick={() => setModalState({ actionKey: 'Choose Course', row: [] })}>
          Choose Course
        </Button>
      }
    >
      <GlobalTable
        tableState={tableState}
        setTableState={setTableState}
        rowUniqueId="placement_tracker_id"
        headers={header}
        rows={placementTrackerTableData ?? []}
        loading={placementTrackerTableLoading}
        meta={meta}
        onButtonActionClick={handleButtonActionClick}
      />
      <GlobalDialog
        title={activeConfig?.title}
        open={Boolean(modalState?.actionKey)}
        setOpen={(val) => {
          if (!val) setModalState({ actionKey: '', row: null });
        }}
        closeButton={true}
        content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
        maxWidth={activeConfig?.maxWidth || 'md'}
      />
    </GlobalWrapper>
  );
}
